import classNames from 'classnames';
import React from 'react';
import { Button } from 'reactstrap';
import { ButtonLoadingIcon } from './ButtonLoadingIcon';

export const ButtonWithLoadingIcon = ({
  className,
  label,
  loading,
  children,
  lowercase,
  height,
  textClassName,
  disabled,
  ...otherProps
}) => (
  <Button
    // outline
    className={`${className ?? ''} mr-0 btn-shadow btn-multiple-state ${
      lowercase ? '' : 'text-uppercase'
    } ${loading ? 'show-spinner' : ''}`}
    style={{
      height: 36,
      paddingTop: 0,
      paddingBottom: 0,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: disabled ? '#EFEB75' : null,
      borderColor: disabled ? '#2E2B2B' : null,
      color: disabled ? '#2E2B2B' : null,
    }}
    disabled={disabled}
    {...otherProps}
  >
    <span
      style={{
        fontFamily: 'Brown Bold',
        letterSpacing: 2,
        fontSize: 14,
      }}
      className={classNames(textClassName, 'label')}
    >
      {children}
    </span>

    <ButtonLoadingIcon />
  </Button>
);
